export default
{
    catName: "vinuri",
    options: {
        showCatTabs: true
    },
    sucategories: [
        {
            id: "m1 crama atelier",
            name_ro: "M1 CRAMA ATELIER",
            desc_ro: "",
            name_eng: "",
            gramaj_st: "",
            prod: [
                {
                    name_ro: "Cramposie",
                    desc_ro: "AREZAN sec / dry, 12.5% alc.",
                    gramaj: "",
                    price: 90,
                },
                {
                    name_ro: "SAUVIGNON Blanc, Chardonnay & Pinot Gris",
                    desc_ro: "SABLE NOBLE sec / dry, 13.5% alc.",
                    gramaj: "",
                    price: 80,
                },
                {
                    name_ro: "CHARDONNAY",
                    desc_ro: "LEAT 6500 THE ORIGIN sec / dry, 14.5% alc.",
                    gramaj: "",
                    price: 140,
                },
                {
                    name_ro: "SAUVIGNON Blanc",
                    desc_ro: "LEAT 6500 THE ORIGIN sec / dry, 13% alc.",
                    gramaj: "",
                    price: 140,
                },
                {
                    name_ro: "PINOT Gris ",
                    desc_ro: "LEAT 6500 THE ORIGIN sec / dry, 13.5% alc. ",
                    gramaj: "",
                    price: 140,
                },
                {
                    name_ro: "MUSCAT Ottonel",
                    desc_ro: "AMPRENTA dulce / sweet 11.5% alc.",
                    gramaj: "",
                    price: 80,
                },
                {
                    name_ro: "TRAMINER",
                    desc_ro: "CHARME DE LA MER demisec / medium dry, 13% alc. ",
                    gramaj: "",
                    price: 95,
                },
                {
                    name_ro: "MERLOT & Cabernet Sauvignon ",
                    desc_ro: "SABLE NOBLE ROSE sec / dry, 13.5% alc. ",
                    gramaj: "",
                    price: 80,
                },
                {
                    name_ro: "MERLOT, Pinot Noir & Cabernet Sauvignon",
                    desc_ro: "LEAT 6500 THE ORIGIN ROSE sec / dry, 13.5% alc.",
                    gramaj: "",
                    price: 140,
                },
                {
                    name_ro: "FETEASCA Neagra, Cabernet Sauvignon & Merlot ",
                    desc_ro: "SABLE NOBLE sec / dry, 13% alc.",
                    gramaj: "",
                    price: 80,
                },
                {
                    name_ro: "BABEASCA Neagra ",
                    desc_ro: "AREZAN sec / dry, 12.5% alc. ",
                    gramaj: "",
                    price: 140,
                },
                {
                    name_ro: "CABERNET Sauvignon & Merlot ",
                    desc_ro: "LEAT 6500 THE ORIGIN sec / dry, 13% alc. ",
                    gramaj: "",
                    price: 140,
                },
                {
                    name_ro: "CABERNET Sauvignon ",
                    desc_ro: "LEAT 6500 THE ORIGIN sec / dry, 13.5% alc. ",
                    gramaj: "",
                    price: 140,
                },
                {
                    name_ro: "SYRAH ",
                    desc_ro: "LEAT 6500 THE ORIGIN sec / dry, 12.5% alc. ",
                    gramaj: "",
                    price: 140,
                },
                {
                    name_ro: "MERLOT ",
                    desc_ro: "LEAT 6500 THE ORIGIN sec / dry, 13.5% alc. ",
                    gramaj: "",
                    price: 140,
                },
                {
                    name_ro: "PINOT NOIR ",
                    desc_ro: "LEAT 6500 THE ORIGIN sec / dry, 13.5% alc. ",
                    gramaj: "",
                    price: 140,
                },
                {
                    name_ro: "MUSCAT OTTONEL",
                    desc_ro: "NOBLE LATE HARVEST dulce / sweet, 375 ml, 11.5% alc. ",
                    gramaj: "",
                    price: 150,
                },
            ],
        },
        {
            id: "crama murfatlar",
            name_ro: "CRAMA MURFATLAR",
            desc_ro: "MURFATLAR DOBROGEA, ROMANIA",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "CHARDONNAY",
                    desc_ro: "ZESTREA demidulce / medium sweet 12% alc",
                    gramaj: "750 ml",
                    price: 45,
                },
                {
                    name_ro: "MUSCAT",
                    desc_ro: "Ottonel ZESTREA demidulce / medium sweet 12% alc.",
                    gramaj: "750 ml",
                    price: 45,
                },
                {
                    name_ro: "CABERNET ",
                    desc_ro: "Sauvignon 3 HECTARE sec / dry, 13% alc.",
                    gramaj: "750 ml",
                    price: 70,
                },

            ]

        },
        {
            id: "tarla",
            name_ro: "TARLA",
            desc_ro: "ROMANIA",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "CHARDONNAY & Sauvignon Blanc",
                    desc_ro: "TARLA 101 sec / dry, LECHINTA TRANSILVANIA 12.5% alc.",
                    gramaj: "750 ml",
                    price: 75,
                },
                {
                    name_ro: "CHARDONNAY",
                    desc_ro: "Barrique TARLA 201 Cuvee sec / dry, TURDA 13% alc",
                    gramaj: "750 ml",
                    price: 120,
                },
                {
                    name_ro: "PINOT Noir ",
                    desc_ro: "TARLA 101 ROSE sec / dry, CRISANA - TRANSILVANIA 12% alc. ",
                    gramaj: "750 ml",
                    price: 75,
                },
                {
                    name_ro: "CABERNET Sauvignon, Feteasca Neagra & Merlot ",
                    desc_ro: "TARLA 101 sec / dry, DEALU MARE - CEPTURA 14.5% alc.",
                    gramaj: "750 ml",
                    price: 75,
                },
                {
                    name_ro: "CABERNET Sauvignon & Feteasca Neagra ",
                    desc_ro: "TARLA 201 sec / dry, DEALU MARE 14.5% alc. ",
                    gramaj: "750 ml",
                    price: 120,
                },

            ]

        },
        {
            id: "davino",
            name_ro: "DAVINO",
            desc_ro: "DEALU MARE CEPTURA, ROMANIA",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "SAUVIGNON Blanc, Feteasca Alba & Riesling Italico",
                    desc_ro: "DOMAINE CEPTURA BLANC sec / dry, 13% alc.",
                    gramaj: "750 ml",
                    price: 160,
                },
                {
                    name_ro: "CABERNET Sauvignon & Merlot ",
                    desc_ro: "DOMAINE CEPTURA ROSE sec / dry, 12.9% alc. ",
                    gramaj: "750 ml",
                    price: 160,
                },
                {
                    name_ro: "CABERNET Sauvignon, Merlot & Feteasca ",
                    desc_ro: "Neagra DOMAINE CEPTURA ROUGE sec / dry, 14.6% alc.",
                    gramaj: "750 ml",
                    price: 210,
                },
                {
                    name_ro: "CABERNET Sauvignon, Merlot & Feteasca Neagra ",
                    desc_ro: "FLAMBOYANT sec / dry, 14.7% alc. ",
                    gramaj: "750 ml",
                    price: 350,
                },


            ]
        },
        {
            id: "jidvei",
            name_ro: "JIDVEI",
            desc_ro: "TARNAVE, ROMANIA ",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "SAUVIGNON Blanc",
                    desc_ro: "ANA OWNER'S CHOICE sec / dry, 12.5%",
                    gramaj: "750 ml",
                    price: 160,
                },
                {
                    name_ro: "CHARDONNAY",
                    desc_ro: "ANA OWNER'S CHOICE sec / dry, 12.5% alc. ",
                    gramaj: "750 ml",
                    price: 160,
                },
                {
                    name_ro: "CUPAJ Alb ",
                    desc_ro: "MYSTERIUM sec / dry, 12% alc",
                    gramaj: "750 ml",
                    price: 120,
                },
                {
                    name_ro: "FETEASCA Regala ",
                    desc_ro: "GAMA TRADITIONALA demisec / medium dry, 11.5% alc. ",
                    gramaj: "750 ml",
                    price: 45,
                },
                {
                    name_ro: "MUSCAT ",
                    desc_ro: "GRIGORESCU demisec / medium dry, 12% alc",
                    gramaj: "750 ml",
                    price: 60,
                },
                {
                    name_ro: "SAUVIGNON Blanc ",
                    desc_ro: "NEC PLUS ULTRA demisec / medium dry, 12% alc.",
                    gramaj: "750 ml",
                    price: 65,
                },
                {
                    name_ro: "SAUVIGNON Blanc & Feteasca Regala ",
                    desc_ro: "TEZAUR sec / dry, 12% alc. ",
                    gramaj: "750 ml",
                    price: 90,
                },
                {
                    name_ro: "RIESLING ",
                    desc_ro: "TEZAUR sec / dry, 12% alc",
                    gramaj: "750 ml",
                    price: 90,
                },
                {
                    name_ro: "ROSE ",
                    desc_ro: "GRIGORESCU demisec / medium dry, 12% alc. ",
                    gramaj: "750 ml",
                    price: 60,
                },
                {
                    name_ro: "CUPAJ Rose ",
                    desc_ro: "MYSTERIUM sec / dry, 12.5% alc. ",
                    gramaj: "750 ml",
                    price: 120,
                },
            ]

        },
        {
            id: "avincis",
            name_ro: "AVINCIS",
            desc_ro: "DRAGASANI, ROMANIA",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "CRAMPOSIE ",
                    desc_ro: "Selectionata sec / dry, 13% alc. ",
                    gramaj: "750 ml",
                    price: 95,
                },
                {
                    name_ro: "SAUVIGNON Blanc ",
                    desc_ro: "PETIT CUVEE sec / dry, 13.5% alc. ",
                    gramaj: "750 ml",
                    price: 95,
                },
                {
                    name_ro: "NEGRU de Dragasani ",
                    desc_ro: "sec / dry, 15% alc. ",
                    gramaj: "750 ml",
                    price: 155,
                },

            ]

        },
        {
            id: "budureasca",
            name_ro: "BUDUREASCA",
            desc_ro: "DEALU MARE, ROMANIA",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "CHARDONNAY, Sauvignon Blanc & Pinot Gris",
                    desc_ro: "Gris PREMIUM FUME sec / dry, 13.5% alc. ",
                    gramaj: "750 ml",
                    price: 110,
                },
                {
                    name_ro: "SAUVIGNON Blanc ",
                    desc_ro: "PREMIUM sec / dry, 13.5% alc. ",
                    gramaj: "750 ml",
                    price: 110,
                },
                {
                    name_ro: "TAMAIOASA Romaneasca",
                    desc_ro: "PREMIUM sec / dry, 13% alc. ",
                    gramaj: "750 ml",
                    price: 110,
                },
                {
                    name_ro: "PINOT Noir, Shiraz & Merlot ",
                    desc_ro: "PREMIUM sec / dry, 13.5% alc. ",
                    gramaj: "750 ml",
                    price: 110,
                },
                {
                    name_ro: "FETEASCA Neagra ",
                    desc_ro: "PREMIUM sec / dry, 14.5% alc.",
                    gramaj: "750 ml",
                    price: 110,
                },
                {
                    name_ro: "CABERNET Sauvignon ",
                    desc_ro: "PREMIUM sec / dry, 14.% alc. ",
                    gramaj: "750 ml",
                    price: 110,
                },
                {
                    name_ro: "MERLOT, Feteasca Neagra, Shiraz, Pinot Noir & Cabernet Sauvignon ",
                    desc_ro: "NOBLE V sec / dry, 14.5% alc. ",
                    gramaj: "750 ml",
                    price: 180,
                },
                {
                    name_ro: "SHIRAZ ",
                    desc_ro: "ORIGINI sec / dry, 14.5% alc. ",
                    gramaj: "750 ml",
                    price: 180,
                },
                {
                    name_ro: "CABERNET Sauvignon ",
                    desc_ro: "ORIGINI sec / dry, 14.% alc.",
                    gramaj: "750 ml",
                    price: 180,
                },


            ]

        },
        {
            id: "crama basilescu",
            name_ro: "CRAMA BASILESCU",
            desc_ro: "DEALU MARE, ROMANIA",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "RIESLING Italian ",
                    desc_ro: "ECLIPSE sec / dry, 13% alc. ",
                    gramaj: "750 ml",
                    price: 70,
                },
                {
                    name_ro: "FETEASCA Alba, Chardonnay & Riesling Italian ",
                    desc_ro: "GOLEM sec / dry, 13.4% alc",
                    gramaj: "750 ml",
                    price: 105,
                },
                {
                    name_ro: "FETEASCA Alba ",
                    desc_ro: "INGERI DIN MICUL PARIS sec / dry, 13.8% alc. ",
                    gramaj: "750 ml",
                    price: 90,
                },
                {
                    name_ro: "ROSE Burgund ",
                    desc_ro: "ECLIPSE demidulce / medium sweet 14.9% alc. ",
                    gramaj: "750 ml",
                    price: 65,
                },
                {
                    name_ro: "MERLOT ",
                    desc_ro: "ECLIPSE sec / dry, 14.9% alc. ",
                    gramaj: "750 ml",
                    price: 70,
                },
                {
                    name_ro: "FETEASCA Neagra, Cabernet Sauvignon & Merlot",
                    desc_ro: "GOLEM sec / dry, 14.9% alc.",
                    gramaj: "750 ml",
                    price: 200,
                },
                {
                    name_ro: "FETEASCA Neagra ",
                    desc_ro: "INGERI DIN MICUL PARIS sec / dry, 14.8% alc.",
                    gramaj: "750 ml",
                    price: 185,
                },
            ]

        },
        {
            id: "crama oprisor",
            name_ro: "CRAMA OPRISOR",
            desc_ro: "MEHEDINTI, ROMANIA ",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "CHARDONNAY, Sauvignon Blanc, Riesling & Pinot Gris ",
                    desc_ro: "RUSALCA ALBA sec / dry, 13% alc. ",
                    gramaj: "750 ml",
                    price: 150,
                },
                {
                    name_ro: "CABERNET Sauvignon, Merlot, Shiraz & Pinot Noir ",
                    desc_ro: "DRAGAICA ROSIE sec / dry, 14% alc. ",
                    gramaj: "750 ml",
                    price: 150,
                },
                {
                    name_ro: "SAUVIGNON ",
                    desc_ro: "CABERNET sec / dry, 14.5% alc. ",
                    gramaj: "750 ml",
                    price: 225,
                },
                {
                    name_ro: "CUPAJ ",
                    desc_ro: "ISPITA sec / dry, 14.5% alc.",
                    gramaj: "750 ml",
                    price: 350,
                },
                {
                    name_ro: "SHIRAZ, Pinot Noir & Dornfelder ",
                    desc_ro: "SHIRAZ, Pinot Noir & Dornfelder ",
                    gramaj: "750 ml",
                    price: 225,
                },
            ]
        },
        {
            id: "vinarte",
            name_ro: "VINARTE",
            desc_ro: "ROMANIA",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "NEGRU de Dragasani, Feteasca Neagra & Novac ",
                    desc_ro: "NEDEEA sec / dry, Starmina - Mehedinti 13.5% alc.",
                    gramaj: "750 ml",
                    price: 90,
                },
                {
                    name_ro: "MERLOT ",
                    desc_ro: "PRINCE MIRCEA sec / dry, Starmina - Mehedinti 13.5% alc. ",
                    gramaj: "750 ml",
                    price: 130,
                },
                {
                    name_ro: "MERLOT ",
                    desc_ro: "PRINCE MATEI sec / dry, Dealu Mare 14.5% alc. ",
                    gramaj: "750 ml",
                    price: 195,
                },
                {
                    name_ro: "CABERNET Sauvignon ",
                    desc_ro: "SOARE sec / dry, Samburesti 13.5% alc. ",
                    gramaj: "750 ml",
                    price: 195,
                },
            ]

        },
        {
            id: "prince stirbey",
            name_ro: "PRINCE STIRBEY",
            desc_ro: "DRAGASANI, ROMANIA ",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "CRAMPOSIE ",
                    desc_ro: "sec / dry, 12.5% alc. ",
                    gramaj: "750 ml",
                    price: 110,
                },
                {
                    name_ro: "NOVAC ",
                    desc_ro: "sec / dry, 13% alc. ",
                    gramaj: "750 ml",
                    price: 160,
                },
                {
                    name_ro: "NEGRU de Dragasani ",
                    desc_ro: "sec / dry, 15.5% alc. ",
                    gramaj: "750 ml",
                    price: 160,
                },
            ]
        },
        {
            id: "cramele halewood",
            name_ro: "CRAMELE HALEWOOD",
            desc_ro: "DEALU MARE, ROMANIA ",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "FETEASCA Regala ",
                    desc_ro: "demisec / medium dry, PRAHOVA VALLEY SPECIAL RESERVE - DEALURILE MUNTENIEI 12.5% alc. ",
                    gramaj: "750 ml",
                    price: 65,
                },
                {
                    name_ro: "CHARDONNAY, Viognier & Feteasca Alba ",
                    desc_ro: "sec / dry, COLINA - DEALURILE MUNTENIEI 13.5% alc.",
                    gramaj: "750 ml",
                    price: 120,
                },
                {
                    name_ro: "PINOT Noir Rose ",
                    desc_ro: "sec / dry, COLINA - DEALURILE MUNTENIEI 13.5% alc. ",
                    gramaj: "750 ml",
                    price: 120,
                },
                {
                    name_ro: "CABERNET Sauvignon, Shiraz & Cabernet Franc",
                    desc_ro: "sec / dry, COLINA - DEALURILE MUNTENIEI 13.5% alc.",
                    gramaj: "750 ml",
                    price: 120,
                },
                {
                    name_ro: "FETEASCA Neagra ",
                    desc_ro: "demisec / medium dry, PRAHOVA VALLEY PRIVATE RESERVE - DEALURILE MUNTENIEI 13.5% alc.",
                    gramaj: "750 ml",
                    price: 75,
                },
                {
                    name_ro: "FETEASCA Neagra ",
                    desc_ro: "sec / dry, HYPERION - DEALU MARE 13.5% alc. ",
                    gramaj: "750 ml",
                    price: 250,
                },
            ]

        },
        {
            id: "cramele recas",
            name_ro: "CRAMELE RECAS",
            desc_ro: "RECAS, ROMANIA ",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "CHARDONNAY ",
                    desc_ro: "Barrique SOLE sec / dry, 13% alc. ",
                    gramaj: "750 ml",
                    price: 150,
                },
                {
                    name_ro: "CHARDONNAY ",
                    desc_ro: "LA STEJARI sec / dry, 14% alc. ",
                    gramaj: "750 ml",
                    price: 380,
                },
                {
                    name_ro: "PINOT Noir, Muscat, Sauvignon Blanc, Chardonnay & Feteasca Regala ",
                    desc_ro: "Regala SOLO QUINTA ROSE sec / dry, 13.5% alc. ",
                    gramaj: "750 ml",
                    price: 220,
                },
                {
                    name_ro: "SAUVIGNON Blanc ",
                    desc_ro: "SOLE sec / dry, 13% alc. ",
                    gramaj: "750 ml",
                    price: 150,
                },
                {
                    name_ro: "FETEASCA Regala Barrique ",
                    desc_ro: "SOLE sec / dry, 13.5% alc. ",
                    gramaj: "750 ml",
                    price: 150,
                },
                {
                    name_ro: "SAUVIGNON Blanc ",
                    desc_ro: "CASTEL HUNIADE demisec / medium dry, 11.5% alc. ",
                    gramaj: "750 ml",
                    price: 55,
                },
                {
                    name_ro: "MERLOT ",
                    desc_ro: "SOLE ROSE sec / dry, 12.5% alc. ",
                    gramaj: "750 ml",
                    price: 125,
                },
                {
                    name_ro: "PINOT Noir, Cabernet Sauvignon, Cabernet Franc, Cadarca & Gewurztraminer",
                    desc_ro: "SOLO QUINTA ROSE sec / dry, 13% alc. ",
                    gramaj: "750 ml",
                    price: 200,
                },
                {
                    name_ro: "MERLOT ",
                    desc_ro: "CASTEL HUNIADE demisec / medium dry, 13.5% alc.",
                    gramaj: "750 ml",
                    price: 55,
                },
                {
                    name_ro: "FETEASCA Neagra ",
                    desc_ro: "SELENE sec / dry, 14.5% alc. ",
                    gramaj: "750 ml",
                    price: 150,
                },
                {
                    name_ro: "CABERNET Sauvignon & Merlot ",
                    desc_ro: "CUVEE UBERLAND sec / dry, 15% alc. ",
                    gramaj: "750 ml",
                    price: 250,
                },
            ]
        },
        {
            id: "casa de vinuri cotnari",
            name_ro: "CASA DE VINURI COTNARI",
            desc_ro: "COTNARI, ROMANIA",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "GRASA de Cotnari ",
                    desc_ro: "DOMENII sec / dry, 13.3% alc. ",
                    gramaj: "750 ml",
                    price: 75,
                },

                {
                    name_ro: "TAMAIOASA Romaneasca ",
                    desc_ro: "DOMENII sec / dry, 13.6% alc. ",
                    gramaj: "750 ml",
                    price: 75,
                },
                {
                    name_ro: "BUSUIOACA de Bohotin",
                    desc_ro: "COLOCVIU LA PARIS sec / dry, 13.6% alc. ",
                    gramaj: "750 ml",
                    price: 110,
                },
            ]
        },
        {
            id: "domeniul coroanei",
            name_ro: "DOMENIUL COROANEI",
            desc_ro: "SEGARCEA, ROMANIA",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "SAUVIGNON Blanc ",
                    desc_ro: "PRESTIGE sec / dry, 12.5% alc.",
                    gramaj: "750 ml",
                    price: 110,
                },
                {
                    name_ro: "CHARDONNAY ",
                    desc_ro: "PRESTIGE sec / dry, 13% alc.",
                    gramaj: "750 ml",
                    price: 110,
                },
                {
                    name_ro: "TAMAIOASA Roza ",
                    desc_ro: "ELITE ROSE demidulce / medium sweet, 12.7% alc.",
                    gramaj: "750 ml",
                    price: 150,
                },
                {
                    name_ro: "CABERNET Sauvignon",
                    desc_ro: "ELITE ROSE sec / dry, 13% alc.",
                    gramaj: "750 ml",
                    price: 90,
                },
                {
                    name_ro: "MERLOT ",
                    desc_ro: "PRESTIGE sec / dry, 14% alc. ",
                    gramaj: "750 ml",
                    price: 80,
                },
                {
                    name_ro: "CABERNET Sauvignon ",
                    desc_ro: "PRESTIGE sec / dry, 13.5% alc. ",
                    gramaj: "750 ml",
                    price: 110,
                },
            ]
        },
        {
            id: "tohani",
            name_ro: "TOHANI",
            desc_ro: "DEALU MARE, ROMANIA ",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "CHARDONNAY ",
                    desc_ro: "PRINCIPELE RADU sec / dry, 13.% alc. ",
                    gramaj: "750 ml",
                    price: 170,
                },
                {
                    name_ro: "MERLOT ",
                    desc_ro: "PRINCIPELE RADU sec / dry, 14% alc. ",
                    gramaj: "750 ml",
                    price: 210,
                },
                {
                    name_ro: "FETEASCA Neagra ",
                    desc_ro: "APOGEUM sec / dry, 13.8% alc. ",
                    gramaj: "750 ml",
                    price: 350,
                },
            ]
        },
        {
            id: "liliac",
            name_ro: "LILIAC",
            desc_ro: "LECHINTA TRANSILVANIA, ROMANIA ",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "SAUVIGNON Blanc & Pinot Gris ",
                    desc_ro: "YOUNG FRESH sec / dry, 12.5% alc. ",
                    gramaj: "750 ml",
                    price: 70,
                },
                {
                    name_ro: "FETEASCA Alba & Muscat Ottonel ",
                    desc_ro: "YOUNG FRUITY sec / dry, 12.5% alc. ",
                    gramaj: "750 ml",
                    price: 70,
                },
            ]
        },
        {
            id: "serve",
            name_ro: "S.E.R.V.E.",
            desc_ro: "DEALU MARE, ROMANIA ",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "SAUVIGNON Blanc ",
                    desc_ro: "VINUL CAVALERULUI sec / dry, 12.5% alc. ",
                    gramaj: "750 ml",
                    price: 55,
                },
                {
                    name_ro: "SAUVIGNON Blanc ",
                    desc_ro: "TERRA ROMANA sec / dry, 13.5% alc. ",
                    gramaj: "750 ml",
                    price: 80,
                },
                {
                    name_ro: "MERLOT & Feteasca Neagra ",
                    desc_ro: "TERRA ROMANA ROSE sec / dry, 13.5% alc. ",
                    gramaj: "750 ml",
                    price: 85,
                },
                {
                    name_ro: "PINOT Noir ",
                    desc_ro: "VINUL CAVALERULUI sec / dry, 13.5% ",
                    gramaj: "750 ml",
                    price: 55,
                },
                {
                    name_ro: "FETEASCA Neagra",
                    desc_ro: "TERRA ROMANA sec / dry, 14% alc.",
                    gramaj: "750 ml",
                    price: 80,
                },
            ]
        },
        {
            id: "purcari",
            name_ro: "PURCARI",
            desc_ro: "PURCARI, MOLDOVA ",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "CHARDONNAY & FETEASCA ALBA",
                    desc_ro: "VINOHORA sec / dry, 13.5.% alc.",
                    gramaj: "750 ml",
                    price: 130,
                },
                {
                    name_ro: "FETEASCA NEAGRA & MONTEPULCIANO ROSE ",
                    desc_ro: "VINOHORA sec / dry, 13.5% alc. ",
                    gramaj: "750 ml",
                    price: 130,
                },
                {
                    name_ro: "RARA NEAGRA & MALBEC ",
                    desc_ro: "VINOHORA sec / dry, 13.5% alc. ",
                    gramaj: "750 ml",
                    price: 130,
                },
                {
                    name_ro: "CABERNET Sauvignon, Saperavi & Rara Neagra ",
                    desc_ro: "NEGRU DE PURCARI sec / dry, 13.5% alc.  ",
                    gramaj: "750 ml",
                    price: 25,
                },
            ]
        },
        {
            id: "podgorii din lumea mare - vinuri albe",
            name_ro: "PODGORII DIN LUMEA MARE",
            desc_ro: "VINURI ALBE / WHITE WINES ",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: " VINURI ALBE / WHITE WINES - CHARDONNAY ",
                    desc_ro: "CHABLIS GRAND REGNARD sec / dry, REGNARD - BOURGOGNE, FRANTA 12.5% alc. ",
                    gramaj: "750 ml",
                    price: 400,
                },
                {
                    name_ro: "VINURI ALBE / WHITE WINES - SAUVIGNON Blanc, Muscadelle & Semillon ",
                    desc_ro: "MOUTON CADET sec / dry, BARON PHILIPPE ROTHSCHILD - BORDEAUX, FRANTA 12% alc. ",
                    gramaj: "750 ml",
                    price: 100,
                },
                {
                    name_ro: "VINURI ALBE / WHITE WINES - SAUVIGNON Blanc Reserva",
                    desc_ro: "MAPU sec / dry, BARON PHILIPPE ROTHSCHILD - CHILE 12.5% alc.",
                    gramaj: "750 ml",
                    price: 100,
                },
                {
                    name_ro: "VINURI ROSE / ROSE WINES - CABERNET Sauvignon, Merlot & Cabernet Franc ",
                    desc_ro: "LE ROSE DE MOUTON CADET sec / dry, BARON PHILIPPE ROTHSCHILD - BORDEAUX, FRANTA 12.5% alc. ",
                    gramaj: "750 ml",
                    price: 100,
                },
                {
                    name_ro: "VINURI ROSE / ROSE WINES - GRENACHE, Rolle, Cinsault, Syrah & Mourvedre ",
                    desc_ro: "WHISPERING ANGEL sec / dry, CHATEAU D’ESCLANS - PROVENCE, FRANTA 13% alc. ",
                    gramaj: "750 ml",
                    price: 170,
                },
                {
                    name_ro: "VINURI ROSII / RED WINES - CABERNET Sauvignon, Merlot & Cabernet Franc ",
                    desc_ro: "MOUTON CADET sec / dry, BARON PHILIPPE ROTHSCHILD - BORDEAUX, FRANTA 12.5% alc. ",
                    gramaj: "750 ml",
                    price: 100,
                },
                {
                    name_ro: "VINURI ROSII / RED WINES - MERLOT Reserva ",
                    desc_ro: "MAPU sec / dry, BARON PHILIPPE ROTHSCHILD - CHILE 13% alc. ",
                    gramaj: "750 ml",
                    price: 100,
                },
            ]
        },
        // {
        //     id: "podgorii din lumea mare - vinuri rose",
        //     name_ro: "PODGORII DIN LUMEA MARE ",
        //     desc_ro: "VINURI ROSE / ROSE WINES",
        //     name_eng: "",
        //     gramaj_st: "750 ml",
        //     prod: [
        //         {
        //             name_ro: "CABERNET Sauvignon, Merlot & Cabernet Franc ",
        //             desc_ro: "LE ROSE DE MOUTON CADET sec / dry, BARON PHILIPPE ROTHSCHILD - BORDEAUX, FRANTA 12.5% alc. ",
        //             gramaj: "750 ml",
        //             price: 100,
        //         },
        //         {
        //             name_ro: "GRENACHE, Rolle, Cinsault, Syrah & Mourvedre ",
        //             desc_ro: "WHISPERING ANGEL sec / dry, CHATEAU D’ESCLANS - PROVENCE, FRANTA 13% alc. ",
        //             gramaj: "750 ml",
        //             price: 170,
        //         },
        //     ]
        // },
        // {
        //     id: "podgorii din lumea mare - vinuri rosii",
        //     name_ro: "PODGORII DIN LUMEA MARE ",
        //     desc_ro: "VINURI ROSII / RED WINES",
        //     name_eng: "",
        //     gramaj_st: "750 ml",
        //     prod: [
        //         {
        //             name_ro: "CABERNET Sauvignon, Merlot & Cabernet Franc ",
        //             desc_ro: "MOUTON CADET sec / dry, BARON PHILIPPE ROTHSCHILD - BORDEAUX, FRANTA 12.5% alc. ",
        //             gramaj: "750 ml",
        //             price: 100,
        //         },
        //         {
        //             name_ro: "MERLOT Reserva ",
        //             desc_ro: "MAPU sec / dry, BARON PHILIPPE ROTHSCHILD - CHILE 13% alc. ",
        //             gramaj: "750 ml",
        //             price: 100,
        //         },
        //     ]
        // },
        {
            id: "sampanii",
            name_ro: "CHAMPAGNE",
            desc_ro: "",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "LAURENT PERRIER ",
                    desc_ro: "Brut, FRANTA 12% alc. ",
                    gramaj: "750 ml",
                    price: 450,
                },
                {
                    name_ro: "LAURENT PERRIER ",
                    desc_ro: "Ultra Brut, FRANTA 12% alc. ",
                    gramaj: "750 ml",
                    price: 600,
                },
                {
                    name_ro: "LAURENT PERRIER ",
                    desc_ro: "Cuvee Rose Brut, FRANTA 12% alc. ",
                    gramaj: "750 ml",
                    price: 750,
                },
            ]
        },
        {
            id: "vinuri spumante",
            name_ro: "VIN SPUMANT / SPARKLING WINES",
            desc_ro: "",
            name_eng: "",
            gramaj_st: "750 ml",
            prod: [
                {
                    name_ro: "RECAS MUSE STARS ",
                    desc_ro: "extra brut, ROMANIA 12% alc. ",
                    gramaj: "750 ml",
                    price: 150,
                },
                {
                    name_ro: "MARGARITAR ",
                    desc_ro: "SPUMANT Rose demisec / medium dry, ROMANIA 12% alc. ",
                    gramaj: "750 ml",
                    price: 60,
                },
                {
                    name_ro: "MARTINI ",
                    desc_ro: "PROSECCO extra dry, ITALIA 11.5% alc. ",
                    gramaj: "750 ml",
                    price: 150,
                },
                {
                    name_ro: "MARTINI ",
                    desc_ro: "SPARKLING Brut, ITALIA 11.5% alc.",
                    gramaj: "750 ml",
                    price: 150,
                },
                {
                    name_ro: "MARTINI ",
                    desc_ro: "ASTI Dolce, ITALIA 7.5% alc. ",
                    gramaj: "750 ml",
                    price: 150,
                },
                {
                    name_ro: "MARTINI ",
                    desc_ro: "SPARKLING Rose Brut, ITALIA 9.5% alc. ",
                    gramaj: "750 ml",
                    price: 150,
                },
            ]
        },
        {
            id: "vin la pahar",
            name_ro: "VIN LA PAHAR / BY THE GLASS",
            desc_ro: "TARLA 101, ROMANIA ",
            name_eng: "",
            gramaj_st: "150 ml",
            prod: [
                {
                    name_ro: "ALB ",
                    desc_ro: "Chardonnay & Sauvignon Blanc sec / dry, TRANSILVANIA 12.5% alc. ",
                    gramaj: "150 ml",
                    price: 16,
                },
                {
                    name_ro: "ROSE",
                    desc_ro: "Pinot Noir sec / dry, CRISANA - TRANSILVANIA 12% alc. ",
                    gramaj: "150 ml",
                    price: 16,
                },
                {
                    name_ro: "ROSU",
                    desc_ro: "Cabernet Sauvignon, Feteasca Neagra & Merlot sec / dry, DEALU MARE - CEPTURA 14.5% alc.",
                    gramaj: "150 ml",
                    price: 16,
                },
            ]
        },
        {
            id: "vin la carafa",
            name_ro: "VIN LA CARAFA / BY DECANTER",
            desc_ro: "MURFATLAR, DOBROGEA, ROMANIA ",
            name_eng: "",
            gramaj_st: "1000 ml",
            prod: [
                {
                    name_ro: "ALB",
                    desc_ro: "Cupaj demisec / medium dry, 11% alc. ",
                    gramaj: "1000 ml",
                    price: 42,
                },
                {
                    name_ro: "ROSE",
                    desc_ro: "Cupaj demisec / medium dry, 11.5% alc",
                    gramaj: "1000 ml",
                    price: 42,
                },
                {
                    name_ro: "ROSU",
                    desc_ro: "Cupaj demisec / medium dry, 11% alc.",
                    gramaj: "1000 ml",
                    price: 42,
                },
            ]
        },
    ]
}